import mongoose from 'mongoose';

export function generateMongoId(): string {
  return new mongoose.Types.ObjectId().toHexString();
}
